import { createGlobalStyle, css } from 'styled-components';
import { resetStyles } from "./ResetStyles.js";
import { getThemeCssVariables } from "./getThemeCssVariables.js";
import { getKallistoCssVariables } from "./kallistoTheme/utils/getKallistoCssVariables.js";
export var GlobalStyles = /*#__PURE__*/createGlobalStyle(["", ";", " body{font-family:", ";}"], function (_ref) {
  var shouldResetStyles = _ref.shouldResetStyles;
  return shouldResetStyles ? resetStyles : '';
}, function (_ref2) {
  var useCssVars = _ref2.useCssVars,
    themeTokens = _ref2.themeTokens,
    kallistoTokens = _ref2.kallistoTokens;
  return useCssVars ? css([":root{", ";", ";}"], getThemeCssVariables(themeTokens), kallistoTokens ? getKallistoCssVariables(kallistoTokens) : '') : '';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.commons.font.family;
});